import { render } from "./totp-panel.vue?vue&type=template&id=f3dcd23c"
import script from "./totp-panel.vue?vue&type=script&lang=ts"
export * from "./totp-panel.vue?vue&type=script&lang=ts"
script.render = render

export default script